<template>
  <div class="justify-content-center text-center dp02 p-3">
    <h1>{{ $t('routes.Reservations') }}</h1>
    <JqxScheduler ref="myScheduler"
                  :key="loaded"
                  @editDialogCreate="editDialogCreate(...arguments)"
                  @editDialogOpen="editDialogOpen(...arguments)"
                  @editDialogClose="resetErrors()"
                  :width="width"
                  :height="height"
                  :source="dataAdapter"
                  :statuses="statuses"
                  :date="date"
                  :localization="getLocalization()"
                  :view="view"
                  :appointment-data-fields="appointmentDataFields"
                  :views="views"
                  :show-legend="true"
                  :day-name-format="'abbr'"
                  :theme="'metrodark'"
                  :context-menu="$auth.check(
                    'Permissions.AdminPanel.Reservations.Create'
                  )"
                  :edit-dialog="$auth.check(
                    'Permissions.AdminPanel.Reservations.Edit'
                  )"
                  style="z-index:1"
                  class="mySchedulerClass" />
    <ValidationObserver ref="observer"
                        v-slot="{invalid}"
                        style="max-height:0; overflow: hidden"
                        tag="div">
      <div>
        <div class="jqx-scheduler-edit-dialog-label">
          {{ $t('common.From') }}
        </div>
        <div class="jqx-scheduler-edit-dialog-field col-8">
          <ValidationProvider
            name="from"
            ref="from"
            rules="required"
            v-slot="{errors, classes}">
            <b-form-input
              type="datetime-local"
              size="sm"
              :class="{...classes, myInput: true}"
              v-model="from"
              pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}"
              :value="from" />
            <p class="myInputError">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
        </div>
      </div>
      <div>
        <div class="jqx-scheduler-edit-dialog-label">
          {{ $t('common.To') }}
        </div>
        <div class="jqx-scheduler-edit-dialog-field col-8">
          <ValidationProvider
            name="to"
            ref="to"
            rules="required"
            v-slot="{errors, classes}">
            <b-form-input
              type="datetime-local"
              size="sm"
              :class="{...classes, myInput: true}"
              pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}"
              v-model="to"
              :value="to" />
            <p class="myInputError">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
        </div>
      </div>
      <div>
        <div class="jqx-scheduler-edit-dialog-label">
          {{ $t('entities.ConsultingRoom.Singular') }}
        </div>
        <div class="jqx-scheduler-edit-dialog-field col-8">
          <ValidationProvider
            name="consultingRoom"
            rules="required|mustPickOne"
            ref="consultingRoom"
            v-slot="{errors, classes}">
            <ConsultingRoomInput v-model="consultingRoom"
                                 ref="ConsultingRoomInput"
                                 :class="{...classes, myInput: true}" />
            <p class="myInputError">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
        </div>
      </div>
      <div>
        <div class="jqx-scheduler-edit-dialog-label">
          {{ $t('fields.doctor') }}
        </div>
        <div class="jqx-scheduler-edit-dialog-field col-8">
          <DoctorInput v-model="doctor"
                       ref="DoctorInput" />
        </div>
      </div>
      <div>
        <div class="jqx-scheduler-edit-dialog-label">
          {{ $t('entities.Customer.Singular') }}
        </div>
        <div class="jqx-scheduler-edit-dialog-field col-8">
          <CustomerInput v-model="customer"
                         ref="CustomerInput" />
        </div>
      </div>
      <div>
        <div class="jqx-scheduler-edit-dialog-label">
          {{ $t('fields.reservationType') }}
        </div>
        <div class="jqx-scheduler-edit-dialog-field col-8">
          <ReservationTypeInput v-model="reservationType"
                                ref="ReservationTypeInput" />
        </div>
      </div>
      <div>
        <div class="jqx-scheduler-edit-dialog-label">
          {{ $t('fields.isFake') }}
        </div>
        <div class="jqx-scheduler-edit-dialog-field col-8">
          <ValidationProvider
            name="consultingRoom"
            ref="isFake"
            v-slot="{errors, classes}">
            <b-form-checkbox
              v-model="isFake"
              :value="true"
              :unchecked-value="false" />
            <p class="myInputError">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
        </div>
      </div>
      <div v-show="creating">
        <div class="jqx-scheduler-edit-dialog-label">
          {{ $t('fields.repeatXWeeks') }}
        </div>
        <div class="jqx-scheduler-edit-dialog-field col-8">
          <ValidationProvider
            name="consultingRoom"
            ref="repeat"
            rules="required|greaterOrEqualToZero"
            v-slot="{errors, classes}">
            <b-form-input
              type="number"
              v-model="repeat"
              :class="{...classes, myInput: true}" />
            <p class="myInputError">
              {{ errors[0] }}
            </p>
          </ValidationProvider>
        </div>
      </div>
      <div class="row col-6 offset-6 justify-content-end">
        <b-button
          type="submit"
          class="myButton align-middle"
          @click="
            if(id === 0) {
              createReservation();
            } else {
              editReservation();
            }
          ">
          {{ $t("common.Save") }}
        </b-button>
        <b-button
          v-if="id !== 0 && $auth.check(
            'Permissions.AdminPanel.Reservations.Delete'
          )"
          type="submit"
          class="myButton align-middle"
          @click="
            deleteReservation();
          ">
          {{ $t("common.Remove") }}
        </b-button>
        <b-button
          type="submit"
          class="myButton align-middle"
          @click="
            $refs.myScheduler.closeDialog();
          ">
          {{ $t("common.Cancel") }}
        </b-button>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import JqxScheduler from 'jqwidgets-scripts/jqwidgets-vue/vue_jqxscheduler';
import DoctorInput from '@components/input/DoctorInput';
import CustomerInput from '@components/input/CustomerInput';
import ConsultingRoomInput from '@components/input/ConsultingRoomInput';
import ReservationTypeInput from '@components/input/ReservationTypeInput';

export default {
  name: 'ReservationsCalendar',
  components: {
    JqxScheduler, DoctorInput, CustomerInput, ConsultingRoomInput, ReservationTypeInput
  },
  methods: {
    resetErrors() {
      this.$refs.from.setErrors([]);
      this.$refs.to.setErrors([]);
      this.$refs.repeat.setErrors([]);
      this.$refs.consultingRoom.setErrors([]);
    },
    convertToISO(string) {
      const members = string.split(' ');
      const date = members[0].split('/');
      const time = members[1].split(':');
      time[0] = Number(time[0]) + (members[2] === 'AM' || Number(time[0]) === 12 ? 0 : 12);
      time[0] = time[0] < 10 ? `0${time[0]}` : String(time[0]);
      return `${date[2]}-${date[1]}-${date[0]}T${time[0]}:${time[1]}`;
    },
    editDialogOpen(dialog) {
      const { fields } = dialog.args;
      if (dialog.args.appointment === null) {
        this.creating = true;
        this.id = 0;
        this.consultingRoom = 0;
        this.doctor = 0;
        this.customer = 0;
        this.isFake = false;
        this.reservationType = 0;
        this.repeat = 0;
        this.from = this.convertToISO(fields.from[0].querySelector('input').value);
        this.to = this.convertToISO(fields.to[0].querySelector('input').value);
      } else {
        this.creating = false;
        const data = dialog.args.appointment.originalData;
        this.isFake = data.isFake;
        this.consultingRoom = data.consultingRoom;
        this.id = data.id;
        this.doctor = data.doctor;
        this.customer = data.customer || 0;
        this.reservationType = data.reservationType;
        this.from = this.convertToISO(fields.from.val());
        this.to = this.convertToISO(fields.to.val());
      }
    },
    editDialogCreate(dialog) {
      const { fields } = dialog.args;
      // for some reason if the inputs start out as hidden,
      // the dialog window has a wrong size on the first open
      // this fixes it
      this.$refs.observer.$el.style.maxHeight = '100%';
      this.$refs.observer.$el.style.overflow = 'auto';
      this.emptyContainers(fields);
      fields.descriptionContainer.append(this.$refs.observer.$el);
      this.showInput = true;
    },
    emptyContainers(fields) {
      fields.buttons.hide();
      fields.fromContainer.hide();
      fields.toContainer.hide();
      fields.subjectContainer.empty();
      fields.locationContainer.empty();
      fields.resourceContainer.empty();
      fields.allDayContainer.empty();
      fields.timeZoneContainer.empty();
      fields.repeatContainer.empty();
      fields.colorContainer.empty();
      fields.statusContainer.empty();
      fields.descriptionContainer.empty();
    },
    validate() {
      this.resetErrors();
      let error = false;
      if (this.consultingRoom === 0) {
        this.$refs.consultingRoom.setErrors([this.$t('ViewReservations.MustPickAmbulance')]);
        error = true;
      }

      if (this.repeat < 0 || this.repeat > 12) {
        this.$refs.repeat.setErrors([this.$t('ViewReservations.RepeatNonNegative')]);
        error = true;
      }

      if (new Date(this.from) < new Date()) {
        this.$refs.from.setErrors([this.$t('ViewReservations.MustBeginInTheFuture')]);
        error = true;
      }

      if (new Date(this.to) < new Date(this.from)) {
        this.$refs.to.setErrors([this.$t('ViewReservations.MustHaveNonZeroLength')]);
        error = true;
      }

      if (this.isFake && this.customer !== 0) {
        this.$refs.isFake.setErrors([this.$t('ViewReservations.CannotBeFakeAndHaveACustomer')]);
        error = true;
      }

      return !error;
    },
    async createReservation() {
      if (this.validate()) {
        const dateFrom = new Date(this.from);
        const dateTo = new Date(this.to);
        const offset = dateFrom.getTimezoneOffset() * 60000;
        const start = new Date(dateFrom.getTime() - offset).toISOString();
        const length = Math.abs(dateTo - dateFrom) / 60000;
        this.axios.put('/admin/reservations', {
          ConsultingRoomId: this.consultingRoom,
          ConsultationStart: start,
          ConsultationLength: length,
          CustomerId: this.customer,
          DoctorId: this.doctor === 0 ? null : this.doctor,
          IsFake: this.isFake,
          ReservationType: this.reservationType,
          Repeat: Number(this.repeat)
        })
          .then(() => {
            // eslint-disable-next-line
            this.date = new jqx.date((new Date(this.from)).getFullYear(), (new Date(this.from)).getMonth()+1, (new Date(this.from)).getDate());
            this.$refs.myScheduler.closeDialog();
            this.refresh();
            this.$root.$bvToast.toast(this.$t('ViewReservations.SuccessToast.Body'), {
              title: this.$t('ViewReservations.SuccessToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
          })
          .catch((res) => {
            if (res.status === 409) {
              if (Number(this.repeat) > 0) {
                this.$refs.consultingRoom.setErrors([this.$t('ViewReservations.ConsultingRoomBusyRecurring')]);
              } else {
                this.$refs.consultingRoom.setErrors([this.$t('ViewReservations.ConsultingRoomBusyEdit')]);
              }
            } else {
              this.$root.$bvToast.toast(this.$t('ViewReservations.FailToast.Body'), {
                title: this.$t('ViewReservations.FailToast.Title'),
                variant: 'danger',
                toaster: 'b-toaster-top-right'
              });
            }
          });
      }
    },
    async editReservation() {
      if (this.validate()) {
        const dateFrom = new Date(this.from);
        const dateTo = new Date(this.to);
        const offset = dateFrom.getTimezoneOffset() * 60000;
        const start = new Date(dateFrom.getTime() - offset).toISOString();
        const length = Math.abs(dateTo - dateFrom) / 60000;
        this.axios.post('/admin/reservations', {
          Id: this.id,
          ConsultingRoomId: this.consultingRoom,
          ConsultationStart: start,
          ConsultationLength: length,
          CustomerId: this.customer,
          DoctorId: this.doctor === 0 ? null : this.doctor,
          IsFake: this.isFake,
          ReservationType: this.reservationType
        })
          .then(() => {
            // eslint-disable-next-line
            this.date = new jqx.date((new Date(this.from)).getFullYear(), (new Date(this.from)).getMonth()+1, (new Date(this.from)).getDate());
            this.$refs.myScheduler.closeDialog();
            this.refresh();
            this.$root.$bvToast.toast(this.$t('ViewReservations.SuccessToast.Body'), {
              title: this.$t('ViewReservations.SuccessToast.Title'),
              variant: 'success',
              toaster: 'b-toaster-top-right'
            });
          })
          .catch((res) => {
            if (res.status === 409) {
              this.$refs.consultingRoom.setErrors([this.$t('ViewReservations.ConsultingRoomBusyEdit')]);
            } else {
              this.$root.$bvToast.toast(this.$t('ViewReservations.FailToast.Body'), {
                title: this.$t('ViewReservations.FailToast.Title'),
                variant: 'danger',
                toaster: 'b-toaster-top-right'
              });
            }
          });
      }
    },
    deleteReservation() {
      this.axios.delete(`/admin/reservations/${this.id}`, {
        params: {
          Id: this.id
        }
      }).then(() => {
        // eslint-disable-next-line
        this.date = new jqx.date((new Date(this.from)).getFullYear(), (new Date(this.from)).getMonth()+1, (new Date(this.from)).getDate());
        this.$refs.myScheduler.closeDialog();
        this.refresh();
        this.$root.$bvToast.toast(this.$t('ViewReservations.SuccessToast.Body'), {
          title: this.$t('ViewReservations.SuccessToast.Title'),
          variant: 'success',
          toaster: 'b-toaster-top-right'
        });
      }).catch(() => {
        this.$refs.myScheduler.closeDialog();
        this.$root.$bvToast.toast(this.$t('ViewReservations.FailToast.Body'), {
          title: this.$t('ViewReservations.FailToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });
    },
    refresh() {
      this.axios.get('/admin/reservations')
        .then((res) => {
          const appointments = res.data.result;
          const appointmentsTransformed = appointments.map((x) => {
            let status = '';
            if (x.isFake) {
              status = 'isFake';
            } else if (x.doctorId === null || x.doctorId === 0) {
              status = 'noDoctor';
            } else if (x.customerId === null || x.customerId === 0) {
              status = 'free';
            } else {
              status = 'taken';
            }
            const length = x.conslultationLength.split(':');
            const endDate = new Date(new Date(x.consultationStart).getTime()
            + Number(length[0]) * 3600000
            + Number(length[1]) * 60000
            + Number(length[2]) * 1000);
            return {
              id: x.id,
              doctor: x.doctorId,
              consultingRoom: x.consultingRoomId,
              customer: x.customerId,
              start: new Date(x.consultationStart),
              end: endDate,
              isFake: x.isFake,
              resizable: false,
              draggable: false,
              subject: `${this.$t('entities.Customer.Singular')}: ${x.customer}
            ${this.$t('fields.doctor')}: ${x.doctor}`,
              reservationType: x.reservationType,
              status
            };
          });
          const source = {
            dataType: 'array',
            dataFields: [
              { name: 'id', type: 'int' },
              { name: 'doctor', type: 'int' },
              { name: 'customer', type: 'int' },
              { name: 'start', type: 'date' },
              { name: 'end', type: 'date' },
              { name: 'isFake', type: 'bool' },
              { name: 'consultingRoom', type: 'int' },
              { name: 'resizable', type: 'bool' },
              { name: 'draggable', type: 'bool' },
              { name: 'subject', type: 'string' },
              { name: 'reservationType', type: 'int' },
              { name: 'status', type: 'string' }
            ],
            id: 'id',
            localData: appointmentsTransformed
          };
          // eslint-disable-next-line
          this.dataAdapter = new jqx.dataAdapter(source);
          this.loaded += 1;
        });
    },
    getLocalization() {
      return {
        firstDay: 1,
        days: {
          names: [
            this.$t('calendar.days.Sunday'),
            this.$t('calendar.days.Monday'),
            this.$t('calendar.days.Tuesday'),
            this.$t('calendar.days.Wednesday'),
            this.$t('calendar.days.Thursday'),
            this.$t('calendar.days.Friday'),
            this.$t('calendar.days.Saturday')
          ],
          namesAbbr: [
            this.$t('calendar.daysAbbr.Sun'),
            this.$t('calendar.daysAbbr.Mon'),
            this.$t('calendar.daysAbbr.Tue'),
            this.$t('calendar.daysAbbr.Wed'),
            this.$t('calendar.daysAbbr.Thu'),
            this.$t('calendar.daysAbbr.Fri'),
            this.$t('calendar.daysAbbr.Sat')
          ]
        },
        months: {
          names: [
            this.$t('calendar.months.January'),
            this.$t('calendar.months.February'),
            this.$t('calendar.months.March'),
            this.$t('calendar.months.April'),
            this.$t('calendar.months.May'),
            this.$t('calendar.months.June'),
            this.$t('calendar.months.July'),
            this.$t('calendar.months.August'),
            this.$t('calendar.months.September'),
            this.$t('calendar.months.October'),
            this.$t('calendar.months.November'),
            this.$t('calendar.months.December'), ''],
          namesAbbr: [
            this.$t('calendar.monthsAbbr.Jan'),
            this.$t('calendar.monthsAbbr.Feb'),
            this.$t('calendar.monthsAbbr.Mar'),
            this.$t('calendar.monthsAbbr.Apr'),
            this.$t('calendar.monthsAbbr.May'),
            this.$t('calendar.monthsAbbr.Jun'),
            this.$t('calendar.monthsAbbr.Jul'),
            this.$t('calendar.monthsAbbr.Aug'),
            this.$t('calendar.monthsAbbr.Sep'),
            this.$t('calendar.monthsAbbr.Oct'),
            this.$t('calendar.monthsAbbr.Nov'),
            this.$t('calendar.monthsAbbr.Dec'),
            '']
        },
        agendaDateColumn: this.$t('calendar.agendaDateColumn'),
        agendaTimeColumn: this.$t('calendar.agendaTimeColumn'),
        agendaAppointmentColumn: this.$t('calendar.agendaAppointmentColumn'),
        backString: this.$t('calendar.backString'),
        forwardString: this.$t('calendar.forwardString'),
        toolBarPreviousButtonString: this.$t('calendar.toolBarPreviousButtonString'),
        toolBarNextButtonString: this.$t('calendar.toolBarNextButtonString'),
        emptyDataString: this.$t('calendar.emptyDataString'),
        loadString: this.$t('calendar.loadString'),
        clearString: this.$t('calendar.clearString'),
        todayString: this.$t('calendar.todayString'),
        dayViewString: this.$t('calendar.dayViewString'),
        weekViewString: this.$t('calendar.weekViewString'),
        monthViewString: this.$t('calendar.monthViewString'),
        editDialogTitleString: this.$t('calendar.editDialogTitleString'),
        editDialogCreateTitleString: this.$t('calendar.editDialogCreateTitleString'),
        contextMenuEditAppointmentString: this.$t('calendar.contextMenuEditAppointmentString'),
        contextMenuCreateAppointmentString: this.$t('calendar.contextMenuCreateAppointmentString'),
      };
    }
  },
  data() {
    return {
      width: 1850,
      height: 800,
      doctor: 0,
      customer: 0,
      reservationType: 0,
      consultingRoom: 1,
      isFake: false,
      from: '',
      to: '',
      id: 0,
      showInput: false,
      loaded: 1,
      repeat: 0,
      creating: false,
      statuses: {
        free: '#00FF14',
        noDoctor: 'blue',
        taken: 'red',
        isFake: 'orange'
      },
      // eslint-disable-next-line
      date: new jqx.date(new Date().getFullYear(), new Date().getMonth()+1, new Date().getDate()),
      appointmentDataFields:
        {
          from: 'start',
          to: 'end',
          id: 'id',
          description: 'about',
          location: 'address',
          subject: 'subject',
          style: 'style',
          status: 'status',
          resizable: 'resizable',
          draggable: 'draggable',
          doctor: 'doctor',
          isFake: 'isFake',
          customer: 'customer',
          reservationType: 'reservationType'
        },
      views:
        [
          {
            type: 'weekView',
            showWeekends: true,
            workTime:
                {
                  fromDayOfWeek: 0,
                  toDayOfWeek: 7,
                  fromHour: 7,
                  toHour: 15
                },
            timeRuler: {
              formatString: 'HH:mm',
              scaleStartHour: 7,
              scaleEndHour: 17
            }
          }
        ],
      view: 'weekView',
      // eslint-disable-next-line
      dataAdapter: new jqx.dataAdapter({
        dataType: 'array',
        dataFields: [
          { name: 'id', type: 'int' },
          { name: 'doctor', type: 'int' },
          { name: 'customer', type: 'int' },
          { name: 'start', type: 'date' },
          { name: 'end', type: 'date' },
          { name: 'isFake', type: 'bool' },
          { name: 'consultingRoom', type: 'int' },
          { name: 'resizable', type: 'bool' },
          { name: 'draggable', type: 'bool' },
          { name: 'subject', type: 'string' }
        ],
        id: 'id',
        localData: []
      })
    };
  },
  mounted() {
    this.refresh();
  },
  watch: {
    consultingRoom(val) {
      if (val !== 0) {
        this.$refs.DoctorInput.setDoctor(this.$refs.ConsultingRoomInput.getDoctor(val));
      }
    },
    // eslint-disable-next-line func-names
    '$i18n.locale': function () {
      this.$refs.myScheduler.localization = this.localization;
      this.loaded += 1;
    }
  }
};
</script>
<style lang="scss">
.jqx-scheduler-toolbar-details {
  font-size:30px;
}

.jqx-center-align{
  vertical-align: text-top;
}

.mySchedulerClass > div {
  z-index: 1;
}
</style>
